module.exports = __webpack_public_path__ + "img/gallery-banner-2.93e44d8a.jpeg";